import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function ThankPage()  {
const email = localStorage.getItem("waitlistEmail");

    return (
  <div className="bg-white min-h-screen flex items-center justify-center">
      
      <div className="text-center flex flex-col items-center space-y-2">

        <h1 className="text-7xl sm:text-8xl lg:text-9xl font-black mb-2 bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-clip-text text-transparent leading-tight drop-shadow-sm">
            Storii
          </h1>
        <span className="text-black font-bold text-4xl">
          Thank you for your registration! 
        </span>

       <p className="p-4 max-w-md text-gray-500">
  Welcome to the future of storytelling. Your spot is reserved — we’ll notify you as soon as Storii is ready.
  Get ready to explore, read, and experience stories like never before.
</p>
   <h1 className="text-black font-bold text-4xl">Your registration</h1>
     <ul>
     <li className="p-3 text-black bg-white rounded-xl text-xl shadow-lg hover:shadow-2xl">
      {email}
     </li>
     </ul>
     <div className="absolute bottom-10">
        <p className="text-xl text-gray-400">You can also follow us on:</p>
        <FontAwesomeIcon icon={faTiktok} className="text-2xl" onClick={() => window.location.href = "https://www.tiktok.com/@storii_europa?_r=1&_t=ZS-94ypecrPjjc"}/>
      </div>
      </div>
     
    </div>
    )
}